// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"d9dcf6bce04e77911375","678":"8d88e59d4cd604e61718","883":"167c4db756824eaafe2e"}[chunkId] + ".js";
};